import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

import useAnimate from '../ui/Motion';

import ScrollLitText from '../ui/ScrollLitText';
import { statement } from '../data/site';

/**
 * The one pinned section on the page. It earns the pin: the reader's
 * scroll is what lights the sentence, word by word, so every pixel of
 * the runway is spent revealing text that was not legible before.
 */
export default function Statement({ eyebrow = 'What we do', text = statement }) {
    const ref = useRef(null);
    const reduced = !useAnimate();

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start']
    });

    const glowOpacity = useTransform(scrollYProgress, [0.1, 0.5, 0.9], [0, 0.55, 0]);
    const eyebrowY = useTransform(scrollYProgress, [0, 1], ['30%', '-30%']);

    return (
        <section className="statement" id="statement" ref={ref}>
            <div className="statement__pin">
                <motion.div
                    className="statement__glow"
                    style={reduced ? undefined : { opacity: glowOpacity }}
                    aria-hidden="true"
                />

                <div className="shell statement__body">
                    <motion.span
                        className="t-eyebrow statement__eyebrow"
                        style={reduced ? undefined : { y: eyebrowY }}
                    >
                        {eyebrow}
                    </motion.span>

                    <ScrollLitText className="statement__text" text={text} targetRef={ref} />
                </div>
            </div>
        </section>
    );
}
